import { valtioDevTools } from '@lib/utils/devTools';
import { InteractionState } from '@modules/InteractionsModule/types';
import { proxy } from 'valtio';

export const initialInteractionState: InteractionState = {
  job: {
    loading: false,
    error: undefined,
    items: [],
  },
};

export const interactionState = proxy<InteractionState>(
  initialInteractionState,
);

valtioDevTools(interactionState, 'interactionState');
